// Features/Page-Section/Reinject.ts
function reinjectScript(original) {
  const clone = document.createElement("script");
  clone.textContent = original.textContent;
  cloneAttributes(original, clone);
  original.parentElement?.replaceChild(clone, original);
}
function cloneAttributes(from, to) {
  Array.from(from.attributes).forEach(({ value, name }) => to.setAttribute(name, value));
}

// Features/Page-Section/Component.ts
var parser = new DOMParser;
var parseHTML = (html) => parser.parseFromString(html, "text/html");
var querySections = (document2) => document2.querySelectorAll(`main > *`);

class PageSection extends HTMLElement {
  connectedCallback() {
    this.render();
  }
  async render() {
    const path = `/pages/${this.handle}`;
    const url = new URL(path, location.href);
    const sections = await fetch(url).then((response) => response.text()).then(parseHTML).then(querySections);
    const nodes = Array.from(sections);
    this.replaceChildren(...nodes);
    this.scripts.forEach(reinjectScript);
  }
  get scripts() {
    return this.querySelectorAll(`script`);
  }
  get handle() {
    return this.dataset.handle;
  }
}

// Features/Page-Section/mod.ts
customElements.define("page-section", PageSection);
